import { useEffect } from 'react';

// iOS-style bottom sheet overlay.
export default function Sheet({ open, onClose, title, children, maxHeight = '85vh' }) {
  // Lock the page behind while open — otherwise touch scrolls on Android
  // fall through to the background instead of scrolling the sheet.
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div
        className="relative w-full max-w-lg bg-white rounded-t-3xl shadow-xl flex flex-col"
        style={{ maxHeight }}
      >
        <div className="pt-2 pb-1 flex justify-center shrink-0">
          <div className="w-9 h-1 rounded-full bg-gray-300" />
        </div>
        {title && (
          <div className="px-4 pb-2 flex items-center justify-between shrink-0">
            <h2 className="text-lg font-bold text-gray-900">{title}</h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-gray-100 text-gray-500 text-sm font-bold"
            >
              ✕
            </button>
          </div>
        )}
        <div className="overflow-y-auto overscroll-contain flex-1 pb-[env(safe-area-inset-bottom)]">
          {children}
        </div>
      </div>
    </div>
  );
}
